import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

type WithIsTrailing = { $isTrailing: boolean };

export const SeasonSeriesContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.seasonSeries};

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const Header = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}
    flex: 1;
`;

export const SeriesRecord = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.secondary};
    flex: 1;
    text-align: right;
`;

export const GamesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${BaseStyle.GAP_SIZES.medium}px ${BaseStyle.GAP_SIZES.small}px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.medium}
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        flex-direction: column;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        flex-direction: row;
    }
`;

export const GameContainer = styled.a<{ $isCurrentGame: boolean }>`
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    padding: 10px 12px 10px 4px;
    height: 95px;
    min-width: calc(50% - ${BaseStyle.GAP_SIZES.small / 2}px);
    cursor: ${({ $isCurrentGame }) => ($isCurrentGame ? 'initial' : 'pointer')};

    &:hover {
        border-color: ${({ theme, $isCurrentGame }) => ($isCurrentGame ? theme.Surface.border : theme.Utility.cta)};
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        min-width: calc(50% - ${BaseStyle.GAP_SIZES.medium / 2}px);
    }
`;

export const TeamContainer = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 4px;
`;

export const TeamLogoContainer = styled.div<WithIsTrailing>`
    img {
        opacity: ${({ $isTrailing }) => ($isTrailing ? 0.5 : 'initial')};
        height: 24px;
        width: 36px;
    }
`;

export const TeamName = styled.div<WithIsTrailing>`
    ${BaseStyle.Mixins.fontStyles.ui['16bCaps']}
    color: ${({ $isTrailing, theme }) => ($isTrailing ? theme.Text.secondary : 'initial')};
    padding-left: 4px;
`;

export const SituationDescriptionChipContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    justify-content: center;
    padding-left: 8px;

    ${BaseStyle.Mixins.screenSizes.small} {
        padding-left: 4px;
    }
`;

export const TeamScore = styled.div<WithIsTrailing>`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
    color: ${({ $isTrailing, theme }) => ($isTrailing ? theme.Text.secondary : 'initial')};
    flex: 1;
    text-align: right;
`;

export const GameInfoContainer = styled.div`
    display: flex;
    align-items: center;
    padding-top: 4px;
    padding-left: 10px;
`;

export const GameInfo = styled.div<{ $isRight?: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['12mCaps']}
    color: ${({ theme }) => theme.Text.secondary};
    flex: 1;
    text-align: ${({ $isRight }) => ($isRight ? 'right' : 'initial')};
`;

export const StartInfo = styled(GameInfo)`
    flex: none;
`;

export const PeriodTimeContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall}
    display: flex;
    height: 16px;
    margin-left: -6px;
`;

const PeriodContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12mCaps']}
    border-radius: 4px;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PeriodInfo = styled(PeriodContainer)`
    background: ${({ theme }) => theme.Utility.success};
    color: ${({ theme }) => theme.Text.OppositeSurface.primary};
    min-width: 32px;
    padding: 0 2px;
`;

export const PeriodWithIntermission = styled(PeriodContainer)`
    background: ${({ theme }) => theme.Surface.secondary};
    color: ${({ theme }) => theme.Text.secondary};
    padding: 0 8px;
`;

export const TimeInfo = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12mCaps']}
    display: flex;
    justify-content: center;
    align-items: center;
`;
